export default __webpack_public_path__ + "af8fd9b0af15f30006a14e1a50b94980.svg";